import { SubStep } from 'components/auth/CreateAccount/CreateAccount.types';

export const getAuthSubStepTitle = (subStep: SubStep) => {
  switch (subStep) {
    case 'choose_signup_option':
      return 'Create an Account';
    case 'email':
      return 'Sign up With Email';
    case 'google_attributes':
      return 'Tell us about yourself';
    case 'login':
      return 'Welcome back!';
    case 'forgot_password':
      return 'Create your new password';
    case 'verification_code':
      return 'Enter verification code';
    default:
      return 'Create an Account';
  }
};
